/**
 * 404등 원본 에러 타입을 그대로 사용하는 경우
 * 백엔드에서 별도 가공하지 않은 형태임
 */
export default class ErrorTypeRaw {
    /** ex) Not found */
    error = '';
    /** ex) api/v1/orders */
    path = '';
    /** ex) 404 */
    status = 0;
    /** ex) 2025-01-14T11:11:11.111Z */
    timestamp = '';
    constructor(error = {}) {
        Object.assign(this, error);
    }
}
